import React from "react";
import PropTypes from "prop-types";
import TrialStatusChip from "../../../components/CustomControls/TrialStatusChip";
import moment from "moment";

const TrialStatusHistory = ({ items }) => {
  return (
    <div
      style={{
        width: "100%",
        overflowX: "auto",
        padding: "8px 0",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: 12,
          paddingBottom: 6,
          whiteSpace: "nowrap",
        }}
      >
        {items.map((item, idx) => (
          <div
            key={`${item.status}-${idx}`}
            style={{
              display: "inline-flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
              minWidth: "max-content",
            }}
          >
            <TrialStatusChip status={item.status} />
            <div
              style={{
                marginTop: 6,
                fontSize: 12,
                color: "#6c757d",
                lineHeight: 1.2,
                textAlign: "center",
              }}
              title={
                item.date && !isNaN(new Date(item.date).getTime())
                  ? moment(item.date).format("DD/MM/YYYY HH:mm")
                  : "-"
              }
            >
              {item.date && moment(item.date).format("DD/MM/YYYY HH:mm")}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

TrialStatusHistory.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.oneOf([
        "Proposal",
        "StartUp",
        "OnHold",
        "OnGoing",
        "Recruiting",
        "Discarded",
        "Closed",
      ]).isRequired,
      date: PropTypes.string.isRequired,
    })
  ),
};

export default TrialStatusHistory;
